export class TokenExpiredError extends Error {
  name = 'TokenExpiredError';
}
